/**
 * WordPress components that create the necessary UI elements for the block
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-components/
 */

import { __ } from '@wordpress/i18n';

import {
  TextControl,
  PanelBody,
  PanelRow,
  ToggleControl,
  Button,
  ToolbarGroup,
} from '@wordpress/components';

import { useState, useEffect } from '@wordpress/element';

import {
  useBlockProps,
  useInnerBlocksProps,
  InspectorControls,
  BlockControls,
  RichText,
} from '@wordpress/block-editor';

import { Component } from '@wordpress/element';

import { useSelect, select, dispatch } from '@wordpress/data';

import BiteLinkPanel from '@components/DesignPanel/LinkPanel';
import LinkPicker from '@components/HelperControls/LinkPicker';

export default function Edit({ attributes, setAttributes, clientId }) {
  // link attributes
  const {
    linkUrl,
    linkTitle,
    linkTarget,
    linkTile,
    linkTextCustom,
    biteStyle,
    biteClass,
    flexClass,
    flexStyle,
    bitePreset,
    buttonType,
    interaction,
  } = attributes;

  // update attribute
  const linkCallback = (link) => {
    changeHeading(link);
    // set custom link text to false
    setAttributes({ ...link, linkTextCustom: false });
  };

  let biteBlockClass = ['bf_layout', flexClass];
  biteBlockClass = biteBlockClass.join(' ');

  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    {
      className: `${biteBlockClass}`,
    },
    {
      template: [
        ['blockbite/icon'],
        [
          'blockbite/button-content',
          { content: linkTitle, contentString: true },
        ],
      ],
    }
  );

  const blockProps = useBlockProps();

  // prevent from opening link
  const handleClick = (event) => {
    event.preventDefault();
    // Additional logic or actions you want to perform when the button is clicked
  };

  const changeHeading = (link) => {
    const headingBlock = getHeadingBlock();
    if (headingBlock && link.linkTitle) {
      dispatch('core/block-editor').updateBlockAttributes(
        headingBlock.clientId,
        { content: link.linkTitle, contentString: true }
      );
    }
  };

  const getHeadingBlock = () => {
    // get children
    const children =
      select('core/block-editor').getBlocksByClientId(clientId)[0].innerBlocks;
    // get heading
    let block = null;
    // loop through children
    children.forEach((child) => {
      if (child.name === 'blockbite/button-content') {
        block = child;
      }
    });
    return block;
  };

  return (
    <>
      <InspectorControls>
        <PanelBody
          title={__('Link Settings', 'blockbite-link')}
          initialOpen={true}
        >
          <BiteLinkPanel
            parentCallback={(linkObj) => linkCallback(linkObj)}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            linkTile={linkTile}
            showLinkTile={true}
          />
        </PanelBody>
      </InspectorControls>
      <BlockControls group="other">
        <ToolbarGroup>
          <LinkPicker
            parentCallback={linkCallback}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            linkTile={linkTile}
            showLinkTile={false}
          />
        </ToolbarGroup>
      </BlockControls>
      {buttonType === 'a' ? (
        <a
          {...blockProps}
          href={linkUrl}
          target={linkTarget}
          rel={'noopener'}
          onClick={(e) => handleClick(e)}
        >
          <span {...innerBlocksProps}>{children}</span>
        </a>
      ) : (
        <button {...blockProps}>
          <span {...innerBlocksProps}>{children}</span>
        </button>
      )}
    </>
  );
}
